// eslint-disable-next-line no-restricted-syntax
export enum SearchResultType {
  Thread = 'Thread',
  Group = 'Group',
  User = 'User',
  File = 'File',
  Inbox = 'Inbox',
  Storyline = 'Storyline',
  Topic = 'Topic',
  NetworkQuestion = 'NetworkQuestion',
  Campaign = 'Campaign',
}
